import {v4 as uuidv4} from "uuid";
import {faker}  from "@faker-js/faker";
import { regions } from "./regions";
import { getOrgApp } from "../helpers/get-orgApp";
import moment from "moment";

const resourceKeys = {
  Instance: "i",
  Volume: "vol",
  Snapshot: "snap",
  Lambda: "lambda",
  S3: "s3",
  IAMRole: "iam",
};

function generateResources(type, count) {
  const resourceTemplate = {
    IAMRole: {
      Type: "IAMRole",
      Findings: "IAM Role is never used",
      Recommendation: "CleanUp Unused IAM Role",
      Name: "IAMRole",
      Cost: null,
    },
    S3: {
      Type: "S3",
      Findings: "S3 Bucket is empty",
      Recommendation: "CleanUp Unused S3 Bucket",
      Name: "S3Bucket",
      Cost: null,
    },
    Volume: {
      Type: "Volume",
      Findings: "Volume is not attached with any instance",
      Recommendation: "CleanUp Unused Volume",
      Name: "Volume",
    },
    Snapshot: {
      Type: "Snapshot",
      Findings: "Unattached snapshot to any AMI",
      Recommendation: "CleanUp Unused Snapshot",
      Name: "Snapshot",
    },
    Instance: {
      Type: "Instance",
      Findings: "Over Provisioned",
      Recommendation: "Modify the instance type",
      Name: "Instance",
    },
    Lambda: {
      Type: "Lambda",
      Findings: "Over Provisioned",
      Recommendation:
        "Modify the configured memory or CPU power to run your workload.",
      Name: "LambdaFunction",
    },
  };

  const resources = [];
  for (let i = 0; i < count; i++) {
    const resource = { ...resourceTemplate[type] };
    resource.Name = `${resource.Name}-${i}`;
    resources.push(resource);
  }
  return resources;
}

export const getResourceInsights = async (type, limit = 20, offset) => {
  let serverOffset = 1;
  if (offset) {
    serverOffset = offset + 1;
  }
  const foundInsights = generateResources(type, limit);
  const mappedInsights = await Promise.all(
    foundInsights.map(async (insight) => {
      const i = await addResourceInsight(insight);
      return i;
    })
  );

  return { Findings: mappedInsights, Offset: serverOffset };
};

const addResourceInsight = async (insight) => {
  const regionCodes = regions.map((reg) => reg.RegionCode);
  const _regionCode = faker.helpers.arrayElement(regionCodes);
  let orgAppDetails = await getOrgApp();
  let selectedOrg = faker.helpers.arrayElement(orgAppDetails);
  let selectedDept = faker.helpers.arrayElement(selectedOrg.depts);
  let selectedDeptApp = faker.helpers.arrayElement(selectedDept.deptApps);
  let selectedDeptAccount = faker.helpers.arrayElement(
    selectedDept.deptAccounts
  );
  const _accountNumber = selectedDeptAccount.accountNumber;
  const { Type, Findings, Recommendation, Cost } = insight;
  return {
    ID: uuidv4(),
    AccountNumber: _accountNumber,
    ApplicationId: selectedDeptApp && selectedDeptApp.appId,
    DepartmentId: selectedDeptApp && selectedDeptApp.appDeptId,
    Region: _regionCode,
    Findings,
    ResourceId: `${resourceKeys[Type]}-${faker.random.alphaNumeric(10)}`,
    ResourceType: Type,
    ResourceName: insight.Name || `Test-${resourceKeys[Type]}`,
    Cost: Cost === null ? null : faker.number.int({ min: 10, max: 70 }),
    Recommendation,
    UpdatedAt: moment(new Date()),
    Metadata: {
      RecommendationOptions: [
        {
          Rank: 1,
          InstanceType: "m5.xlarge",
        },
      ],
    },
  };
};

const abandonedResources = {
  IAMRole: 4,
  S3: 4,
  Volume: 3,
  Snapshot: 2,
};

const underProvisionedResources = {
  Instance: 4,
  Lambda: 4,
};

const overProvisionedResources = {
  Instance: 4,
  Lambda: 4,
};

const usageOptimization = {
  Instance: 2,
  Volume: 2,
  Lambda: 4,
};

export const getResourceInsightSummary = (filters) => {
  const { Type } = filters;
  let summary = {};
  switch (Type) {
    case "abandoned_resources":
      summary = abandonedResources;
      break;
    case "under_provisioned_resources":
      summary = underProvisionedResources;
      break;
    case "over_provisioned_resources":
      summary = overProvisionedResources;
      break;
    case "usage_optimization":
      summary = usageOptimization;
      break;
    default:
      break;
  }
  return summary;
};

export const getResourceInsightTypes = () => {
  return ["IAMRole", "S3", "Volume", "Snapshot", "Instance", "Lambda"];
};
